export default "__VITE_ASSET__0wKLz8JJ__"